'use client'

import { useEffect } from 'react'
import { useUser } from '@/providers/UserContext'
import { portalApiClient } from '@/utilities/api'
import * as PayloadAPI from '@/repositories/payloadRepository'
import * as AuthAPI from '@/repositories/authRepository'
import * as OrdersAPI from '@/repositories/ordersRepository'
import * as PartnersAPI from '@/repositories/partnersRepository'
import * as KitsAPI from '@/utilities/axios/api/kits'
import * as UserAPI from '@/utilities/axios/api/user'
import * as PartnerAPI from '@/utilities/axios/api/partner'
import * as ClientUsersAPI from '@/repositories/clientUsersRepository'

declare global {
  interface Window {
    AshAPI?: {
      api: typeof portalApiClient
      payload: typeof PayloadAPI
      auth: typeof AuthAPI
      orders: typeof OrdersAPI
      partners: typeof PartnersAPI
      clientUsers: typeof ClientUsersAPI
      kits: typeof KitsAPI
      user: typeof UserAPI
      partner: typeof PartnerAPI
    }
  }
}

export function AshAPIInit() {
  const { user } = useUser()

  useEffect(() => {
    if (typeof window === 'undefined') return
    const email = user?.email_address || ''
    const isAsh = /@poweredbyash\.com$/i.test(email)
    if (!isAsh) return

    window.AshAPI = {
      api: portalApiClient,
      payload: PayloadAPI,
      auth: AuthAPI,
      orders: OrdersAPI,
      partners: PartnersAPI,
      clientUsers: ClientUsersAPI,
      user: UserAPI,
      kits: KitsAPI,
      partner: PartnerAPI,
    }
  }, [user])

  return null
}

export default AshAPIInit
